import { Calendar, Plus, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { clientIdFromPath } from '../lib/client-screen';
import { useAuth } from '../store/auth.tsx';
import TransitionLink from './TransitionLink';
import TransitionNavLink from './TransitionNavLink';

const Sidebar = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const clientId = clientIdFromPath(location.pathname);
  const from = `${location.pathname}${location.search}`;
  const newState = {
    ...(clientId ? { clientId } : {}),
    from,
  };

  const navItems = [
    { name: t('Сегодня'), icon: Calendar, path: '/' },
    { name: t('Добавить'), ariaLabel: t('+ Добавить'), icon: Plus, path: '/new' },
    { name: t('Клиенты'), icon: Users, path: '/clients' },
  ];

  return (
    <aside className="app-sidebar hidden md:flex glass-panel border-r border-app-border flex-col h-screen shrink-0 overflow-hidden w-56">
      <div className="h-[4.25rem] shrink-0 flex items-center px-4 gap-3 border-b border-app-border/60">
        <div className="w-9 h-9 shrink-0 bg-gradient-to-br from-primary to-indigo-400 text-white flex items-center justify-center rounded-xl font-bold text-lg shadow-glow">
          P
        </div>
        <div className="flex-1 min-w-0">
          <span className="text-lg font-bold text-slate-900 tracking-tight">ProТренерофф</span>
          <p className="section-label -mt-0.5">
            {t('Коуч')}
          </p>
        </div>
      </div>

      <nav className="flex-1 min-h-0 overflow-y-auto overscroll-contain px-3 py-4 flex flex-col gap-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <TransitionNavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              state={item.path === '/new' ? newState : undefined}
              aria-label={'ariaLabel' in item ? item.ariaLabel : item.name}
              className={({ isActive }) =>
                `nav-link ${isActive ? 'nav-link-active' : 'nav-link-inactive'}`
              }
            >
              <Icon size={20} strokeWidth={2} className="shrink-0" />
              <span className="truncate">{item.name}</span>
            </TransitionNavLink>
          );
        })}
      </nav>

      <div className="shrink-0 border-t border-app-border/60 p-3">
        <TransitionLink
          to="/profile"
          state={{ from }}
          aria-label={t('Профиль')}
          className="flex items-center gap-3 p-3 rounded-2xl hover:bg-primary/5"
        >
          <div className="w-10 h-10 shrink-0 rounded-xl bg-gradient-to-br from-primary/20 to-indigo-100 text-primary flex items-center justify-center font-bold text-sm">
            {user?.name?.charAt(0)}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-slate-900 truncate">{user?.name}</p>
            <p className="text-xs text-app-muted">{t('Коуч')}</p>
          </div>
        </TransitionLink>
      </div>
    </aside>
  );
};

export default Sidebar;
